<template>
  <div class="create-email">
    <!-- :save-disabled="tab1Error || tab2Error || !name" -->
    <form-header
      :emailid="emailid"
      :email-name="name"
      :auto="auto"
      :sendnow="sendnow"
      :status="emailInfo.status"
      @getName="getName"
      @save="handleSave"
      @back="back"
    />
    <div class="form-content">
      <a-tabs
        :active-key="activeKey"
        :animated="false"
        @change="handleChange"
      >
        <a-tab-pane
          key="1"
          :force-render="true"
        >
          <span slot="tab">
            编辑
            <i
              v-if="tab1Error"
              class="iconfont iconicon-test68 tab-error-icon"
            />
          </span>
          <edit-email
            ref="editEmail"
            :emailid="emailid"
            :content="content"
          />
        </a-tab-pane>
        <a-tab-pane
          key="2"
          :force-render="true"
        >
          <span slot="tab">
            设置
            <i
              v-if="tab2Error"
              class="iconfont iconicon-test68 tab-error-icon"
            />
          </span>
          <set-email
            ref="setEmail"
            :emailid="emailid"
            :form-data="emailInfo.config"
          />
        </a-tab-pane>
      </a-tabs>
    </div>
    <bug-email-modal :visible.sync="showBuyEmailModal" />
    <test-email-modal
      :visible.sync="showTestEmailModal"
      :email-name="name"
    />
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import FormHeader from './FormHeader'
import EditEmail from './EditEmail'
import SetEmail from './SetEmail'
import BugEmailModal from './BuyModal'
import TestEmailModal from './TestEmailModal'

export default {
  components: {
    FormHeader,
    EditEmail,
    SetEmail,
    BugEmailModal,
    TestEmailModal
  },
  data () {
    return {
      name: '',
      content: '',
      auto: 0,
      sendnow: 1,
      activeKey: '1',
      showBuyEmailModal: false,
      showTestEmailModal: false
    }
  },

  computed: {
    ...mapState('edm/editEmail', ['emailInfo', 'tab1Error', 'tab2Error', 'result']),
    emailid () {
      return this.$route.query.emailid || ''
    },
    tab () {
      return this.$route.query.tab || '1'
    },
    documentTitle () {
      let { projectname = '', comname = '' } = this.$store.state.baseinfo || {}
      projectname && (projectname = ' - ' + projectname)
      comname && (comname = ' - ' + comname)
      return 'EDM营销' + projectname + comname
    }
  },

  watch: {
    tab: {
      handler (val) {
        this.activeKey = val + ''
      },
      immediate: true
    },
    emailid: {
      handler (val) {
        if (!val) { // 创建邮件时，初始化数据
          this.name = '未命名邮件'
          this.content = ''
          this.auto = 0
          this.sendnow = 1

          let emailInfo = {
            name: this.name,
            content: this.content,
            id: '',
            config: {
              auto: 0,
              triggervalue: [],
              triggervaluestr: '',
              contactid: '',
              from: '',
              fromemail: '',
              replyto: '',
              subject: '',
              sendnow: 1,
              plantime: '',
              delaytime: '',
              noticeemail: ''
            }
          }

          this.SET_EMAIL_INFO({ ...emailInfo })
          this.SET_ERROR({ tab1Error: false, tab2Error: false })
        }
      },
      immediate: true
    },
    documentTitle: {
      handler (val) {
        document.title = val
      },
      immediate: true
    }
  },

  async mounted () {
    let _this = this
    if (this.emailid) { // 编辑邮件时，获取邮件详情
      let chain = await this.fetchEmailInfo({
        id: this.emailid,
        isdetails: 1
      })
      chain
        .onSuccess((res = {}) => {
          let { config = {} } = res || {}
          this.name = res.name
          this.content = res.content
          _this.auto = config.auto
          _this.sendnow = config.sendnow

          document.title = this.documentTitle

          this.SET_ERROR({ tab1Error: false, tab2Error: false })
        })
    }

    this.$bus.$on('resetTiggerAuto', (auto = 0, sendnow = 1) => {
      this.auto = auto ? 1 : 0
      this.sendnow = sendnow
    })
  },
  beforeDestroy () {
    this.$bus.$off('resetTiggerAuto')
  },

  methods: {
    ...mapActions('edm/editEmail', ['fetchEmailInfo', 'addEmail']),
    ...mapMutations('edm/editEmail', ['SET_ERROR', 'SET_EMAIL_INFO']),

    handleChange (key) {
      this.activeKey = key
      this.$router.push({
        query: {
          ...this.$route.query,
          tab: key
        }
      })
    },
    getName (name) {
      this.name = name
    },
    async handleSave (saveType, sendBtnName) {
      // this.$bus.$emit('myQuillEditorBlur')

      if (saveType === 'priview') { // 点击预览
        this.handlePriview()
        return
      } else if (saveType === 'test') { // 点击测试邮件
        if (this.name === '') {
          this.$message.destroy()
          this.$message.error('邮件名称不能为空')
        } else {
          this.handleTest()
        }
        return
      }

      this.setSaveStatus(saveType, sendBtnName)

      if (saveType === 'draft' && this.$refs.editEmail) { // 点击存草稿，不需要校验
        let err = await this.$refs.editEmail.handleSubmit()
        if (!err) {
          this.SET_EMAIL_INFO({ ...this.emailInfo })
          this.saveAjax(saveType, sendBtnName)
        }
        return
      }
      if (saveType === 'deal' && this.$refs.editEmail && this.$refs.setEmail) {
        const requestAll = Promise.all([
          this.$refs.editEmail.handleSubmit(),
          this.$refs.setEmail.handleSubmit()
        ])
        requestAll.then(res => {
          // res[0] // 校验编辑邮件内容
          // res[1] // 校验设置邮件内容

          if (this.name === '') {
            this.$message.destroy()
            this.$message.error('邮件名称不能为空')
            return
          }
          this.SET_ERROR({ tab1Error: res[0], tab2Error: res[1] })

          if (!this.tab1Error && !this.tab2Error && this.name) {
            this.saveAjax(saveType, sendBtnName)
          }
        })
      }
    },
    setSaveStatus (saveType, sendBtnName) {
      if (saveType === 'draft') { // 点击草稿
        this.emailInfo.status = -1
      } else if (sendBtnName === '保存') { // 点击保存
        this.emailInfo.status = 1
      } else if (sendBtnName === '排期') { // 点击排期
        this.emailInfo.status = 1
      } else if (sendBtnName === '发送') { // 点击发送
        this.emailInfo.status = 1
      }
    },

    async saveAjax (saveType, sendBtnName) {
      let params = {
        ...this.emailInfo,
        id: this.id,
        name: this.name
      }
      if (this.emailid) {
        params.id = this.emailid
      }

      let chain = await this.addEmail(params)
      chain
        .onNetSuccess((raw, re) => {
          // 保存相关事件
          const res = raw.data
          if (res.error) {
            // 失败弹窗提示
            if (res.error === 102) {
              if (this.$toType(res.payload) === 'array' && res.payload[0]) {
                let { message = '' } = res.payload[0]
                this.$message.error(message)
              }
            } else if (res.error === 104) {
              let data = res.payload
              if (sendBtnName === '排期') {
                // 选择了排期发送：排期
                this.handlerSchedules(data)
              } else if (sendBtnName === '发送') {
                // 否则：发送
                this.handlerSend(data)
              }
            }
          } else {
            // 成功后跳转到列表页
            this.$router.push({
              name: 'EmailList'
            })
          }
        }).config({
          error104: false
        })
    },
    back () {
      this.$router.push({ name: 'EmailList' })
    },
    handlerSend (data) {
      let _this = this
      let contactNum = data.contactNum
      let edmNum = data.edmNum
      let instance = this.$confirm({
        title: '无法立即发送当前邮件',
        content: <div><p>当前要发送的邮件面向{contactNum}个联系人，当前可用邮件发送量为{edmNum}封。</p><p>如需继续发送，请购买发送量。 </p></div>,
        okText: '立即购买',
        okType: 'primary',
        cancelText: '稍后进行',
        class: 'confirm-warn-modal del-email-modal',
        onOk: async () => {
          _this.showBuyEmailModal = true
          instance.destroy()
        }
      })
    },
    handlerSchedules (data) {
      let _this = this
      let time = data.plantime
      let contactNum = data.contactNum
      let edmNum = data.edmNum

      let instance = this.$confirm({
        title: `无法为当前邮件排期至 ${time}`,
        content: <div><p>当前要排期至{time}的邮件面向{contactNum}个联系人，当前可用邮件发送量为{edmNum}封。</p><p> 如需继续发送，请购买发送量。</p></div>,
        closable: true,
        okText: '立即购买',
        okType: 'primary',
        cancelText: '稍后进行',
        class: 'confirm-warn-modal del-email-modal',
        onOk: async () => {
          _this.showBuyEmailModal = true
          instance.destroy()
        }
      })
    },
    async handleTest () {
      this.$refs.editEmail && this.$refs.editEmail.setStorageEmailContent()
      this.showTestEmailModal = true
    },
    handlePriview () {
      this.$refs.editEmail && this.$refs.editEmail.setStorageEmailContent()
    }
  }
}
</script>

<style lang="scss" scoped>
.form-content::v-deep {
  position: relative;
  max-width: 1278px;
  border: 1px solid #ebebeb;
  background: #fff;
  border-radius: 4px;
  margin: 24px auto 32px;

  .ant-tabs-nav {
    margin-left: 24px;
    .ant-tabs-tab {
      margin-right: 24px;
      padding: 12px 0;
      & > span {
        position: relative;
        font-size: 18px;
      }
    }
  }
  .ant-tabs-bar {
    margin-bottom: 0;
    // border-bottom: 0;
  }
  .tab-error-icon {
    position: absolute;
    top: -6px;
    right: -9px;
    color: #F57676;
    font-size: 14px;
  }

}
</style>
